import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Wordmark from '../common/Wordmark';

// A teammate whose studio has had the Team feature switched off (or who was removed
// between two page loads). Shown by TeacherDashboardGuard instead of bouncing them to
// "create your studio", which would be wrong and alarming.
export default function TeamDisabledPage() {
  const { logout } = useAuth();
  return (
    <div className="min-h-screen bg-gray-50 px-4 py-10 flex flex-col items-center">
      <Link to="/" className="mb-8"><Wordmark size="sm" /></Link>
      <div className="w-full max-w-md bg-white rounded-xl border border-gray-100 shadow-sm p-6 sm:p-8 text-center">
        <h1 className="text-lg font-semibold text-gray-900 mb-2">Team access is paused</h1>
        <p className="text-sm text-gray-500 mb-6">Your studio's team access is switched off right now. Ask the studio owner, or the DanceHall team, to turn it back on.</p>
        <button onClick={logout} className="text-sm text-brand-600 hover:text-brand-700 font-medium">Log out</button>
      </div>
    </div>
  );
}
